import { Material } from "#modules/materials/infra/fetchCustomMaterials.api";

export const makeCustomMaterialsCsv = (customMaterials: Material[]) => {
  const separator = ";";
  const csvData = [
    [
      "id",
      "type",
      "subType",
      "name",
      "grade",
      "length",
      "width",
      "height",
      "tubeThickness",
      "density",
      "price",
    ].join(separator),
  ];
  const rows = customMaterials.map((customMaterial) => {
    return [
      customMaterial.id,
      customMaterial.type,
      customMaterial.subType,
      customMaterial.name,
      customMaterial.materialGrade,
      customMaterial.length,
      customMaterial.width,
      customMaterial.height,
      customMaterial.tubeThickness,
      customMaterial.density,
      customMaterial.price,
    ].join(separator);
  });

  return csvData.concat(rows);
};
